"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/* eslint-disable no-underscore-dangle */
var _capabilities = Symbol('capabilities');

var _content = Symbol('content');

var _displayName = Symbol('displayName');

var _gravatar = Symbol('gravatar');

var _initials = Symbol('initials');

var _formattedTime = Symbol('formattedTime');

var _id = Symbol('id');

var _isSelf = Symbol('isSelf');

var _ts = Symbol('ts');

var _type = Symbol('type');

var Item = /*#__PURE__*/function () {
  function Item(_ref) {
    var _ref$capabilities = _ref.capabilities,
        capabilities = _ref$capabilities === void 0 ? {} : _ref$capabilities,
        _ref$content = _ref.content,
        content = _ref$content === void 0 ? null : _ref$content,
        _ref$displayName = _ref.displayName,
        displayName = _ref$displayName === void 0 ? null : _ref$displayName,
        _ref$gravatar = _ref.gravatar,
        gravatar = _ref$gravatar === void 0 ? null : _ref$gravatar,
        _ref$initials = _ref.initials,
        initials = _ref$initials === void 0 ? '' : _ref$initials,
        _ref$formattedTime = _ref.formattedTime,
        formattedTime = _ref$formattedTime === void 0 ? null : _ref$formattedTime,
        _ref$id = _ref.id,
        id = _ref$id === void 0 ? null : _ref$id,
        _ref$isSelf = _ref.isSelf,
        isSelf = _ref$isSelf === void 0 ? false : _ref$isSelf,
        _ref$ts = _ref.ts,
        ts = _ref$ts === void 0 ? 0 : _ref$ts,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'message' : _ref$type;
    (0, _classCallCheck2.default)(this, Item);
    this.capabilities = capabilities;
    this.content = content;
    this.displayName = displayName;
    this.gravatar = gravatar;
    this.initials = initials;
    this.formattedTime = formattedTime;
    this.isSelf = isSelf;
    this.id = id;
    this.ts = ts;
    this.type = type;
  }

  (0, _createClass2.default)(Item, [{
    key: "capabilities",
    get: function get() {
      return this[_capabilities];
    },
    set: function set(capabilities) {
      // eslint-disable-next-line no-return-assign
      return this[_capabilities] = capabilities;
    }
  }, {
    key: "content",
    get: function get() {
      return this[_content];
    },
    set: function set(content) {
      // eslint-disable-next-line no-return-assign
      return this[_content] = content;
    }
  }, {
    key: "displayName",
    get: function get() {
      return this[_displayName];
    },
    set: function set(displayName) {
      // eslint-disable-next-line no-return-assign
      return this[_displayName] = displayName;
    }
  }, {
    key: "gravatar",
    get: function get() {
      return this[_gravatar];
    },
    set: function set(gravatar) {
      // eslint-disable-next-line no-return-assign
      return this[_gravatar] = gravatar;
    }
  }, {
    key: "initials",
    get: function get() {
      return this[_initials];
    },
    set: function set(initials) {
      // eslint-disable-next-line no-return-assign
      return this[_initials] = initials;
    }
  }, {
    key: "id",
    get: function get() {
      return this[_id];
    },
    set: function set(id) {
      // eslint-disable-next-line no-return-assign
      return this[_id] = id;
    }
  }, {
    key: "isSelf",
    get: function get() {
      return this[_isSelf];
    },
    set: function set(isSelf) {
      // eslint-disable-next-line no-return-assign
      return this[_isSelf] = isSelf;
    }
  }, {
    key: "formattedTime",
    get: function get() {
      return this[_formattedTime];
    },
    set: function set(formattedTime) {
      // eslint-disable-next-line no-return-assign
      return this[_formattedTime] = formattedTime;
    }
  }, {
    key: "ts",
    get: function get() {
      return this[_ts];
    },
    set: function set(ts) {
      var date = new Date(ts);
      date = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
      });
      this.formattedTime = date; // eslint-disable-next-line no-return-assign

      return this[_ts] = ts;
    }
  }, {
    key: "type",
    get: function get() {
      return this[_type];
    },
    set: function set(type) {
      // eslint-disable-next-line no-return-assign
      return this[_type] = type;
    }
  }, {
    key: "getCapability",
    value: function getCapability(type) {
      return this[_capabilities][type] || null;
    }
  }, {
    key: "setCapability",
    value: function setCapability(capability) {
      // eslint-disable-next-line no-return-assign
      return this[_capabilities][capability.type] = capability;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        capabilities: this[_capabilities],
        content: this[_content],
        displayName: this[_displayName],
        gravatar: this[_gravatar],
        initials: this[_initials],
        formattedTime: this[_formattedTime],
        id: this[_id],
        ts: this[_ts],
        type: this[_type]
      };
    }
  }]);
  return Item;
}();

exports.default = Item;
module.exports = exports.default;